import React, { useEffect, useState } from "react";
import { generatePath, useNavigate } from "react-router-dom";

/* @ts-ignore */

import TodayStore from "stores/TodayStore";
import ProfileStore from "stores/ProfileStore";
import CoachStore from "stores/CoachStore";

import { Page } from "components/Layout";
import { Placeholders } from "assets/images/placeholders";
import Placeholder from "components/Placeholder";

import { NoInternetConnectionError } from "services/api";

import ROUTES from "navigation/routes";

import { COLLECTION_TYPE } from "constants/collection";

import { observer } from "mobx-react";
import { CollectionWrapper, Background, Wrapper, Title } from "./styles";
import NavList from "./NavList/NavList";
import { withTranslation, WithTranslation } from "react-i18next";
import styleConst from "constants/style";
import withGlobalPopup from "components/Popup/withGlobalPopup";
import type { GlobalPopupProps } from "components/Popup/withGlobalPopup";
import MessagePopup from "components/MessagePopup/MessagePopup";
import { Collection } from "components/Collection";

type Props = {} & WithTranslation & GlobalPopupProps;

const Today: React.FC<Props> = observer(props => {
  const t: (key: string) => string = props.t;
  const navigate = useNavigate();
  const [isNoInternetConnectionError, setIsNoInternetConnectionError] =
    useState(false);

  useEffect(() => {
    const { openPopup } = props;

    const checkAndShowPopup = async () => {
      await ProfileStore.fetch();
      const userId = ProfileStore.userId;

      if (!userId) return;

      const storageKey = `messagePopupSeen:${userId}`;
      const alreadySeen = localStorage.getItem(storageKey);

      if (!alreadySeen) {
        openPopup({
          key: "MessagePopup",
          exitButtonColor: styleConst.colors.black25,
          render: ({ close }: { close: () => void }) => (
            <MessagePopup
              title={t("oneTimeModalCopy")}
              onClose={() => {
                localStorage.setItem(storageKey, "true");
                close();
              }}
            />
          ),
        });
      }
    };

    checkAndShowPopup();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        await Promise.all([
          TodayStore.fetchTodayData(),
          CoachStore.syncCoachConnect(),
        ]);
      } catch (error: any) {
        if (error instanceof NoInternetConnectionError) {
          setIsNoInternetConnectionError(true);
        }
      }
    })();
  }, []);

  const onWorkoutNavigate = (workout: any): void => {
    const { id: workoutId, workoutInWorkoutCategoryId } = workout;
    const workoutCategoryIdValue = workoutInWorkoutCategoryId ?? 0;
    navigate(
      generatePath(ROUTES.TODAY_WORKOUT_DETAILS, {
        workoutId,
        workoutInWorkoutCategoryId: workoutCategoryIdValue,
      }),
    );
  };

  return (
    <Page
      isNoInternetConnectionError={isNoInternetConnectionError}
      isLoading={TodayStore.isLoading}
      title={" "}
      contentBackground={<Background />}
      topNavigation={<NavList />}
    >
      <Wrapper>
        {TodayStore.workouts.length > 0 ? (
          <>
            <CollectionWrapper>
              <Collection
                items={TodayStore.workouts}
                onCardClick={onWorkoutNavigate}
                type={COLLECTION_TYPE.WORKOUT}
                title={<Title>{t("messages.today-workouts")}</Title>}
                show="label"
              />
            </CollectionWrapper>
          </>
        ) : (
          <CollectionWrapper>
            <Title>{t("messages.today-workouts")}</Title>
            <Placeholder
              imageUrl={Placeholders.Workout}
              text={t("messages.no-workouts-today")}
              inline={false}
            />
          </CollectionWrapper>
        )}
      </Wrapper>
    </Page>
  );
});

export default withGlobalPopup(withTranslation()(Today));
